// See https://product-fabric.atlassian.net/browse/PGXT-9417 for more context.
// Module not found errors from failed dynamic imports don't impact customers but skew SLA metrics.
// This utility is shared between CustomMonitoringClient and the experience tracker
// so both can suppress these errors consistently.
export const isModuleNotFoundError = (error: any): boolean => {
	const errorMessage = String(error?.message || error || '');

	return (
		errorMessage.includes('Cannot find module') ||
		errorMessage.includes('Failed to find module') ||
		errorMessage.includes('Module not found')
	);
};
